export const NOTIFICATION_TYPE = {
	INVITE_CAMPAIGN: 'invite_campaign'
}